import _ from "lodash";
import { RESTAURANT_BLACKOUT } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        restaurantBlackout: _.cloneDeep(constants.RESTAURANT_BLACKOUT_INPUT)
    },
}

const restaurantBlackoutReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESTAURANT_BLACKOUT.SET_RESTAURANT_BLACKOUT_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case RESTAURANT_BLACKOUT.SET_RESTAURANT_BLACKOUT:
        case RESTAURANT_BLACKOUT.SET_RESTAURANT_BLACKOUT_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    restaurantBlackout: action.restaurantBlackout
                }
            })
        default:
            return state
    }
}

export default restaurantBlackoutReducer